// Brand tokens as JS constants. Mirror the Tailwind theme in
// frontend/tailwind.config.ts and the prototype's flat ICS object in
// handoff_input/design/screens/shared.jsx.
//
// Tailwind classes (`bg-paper`, `text-rame` …) are the preferred consumer.
// Use these constants only when a class won't reach: inline SVG fills, dynamic
// computed styles driven by props, or third-party libraries that need a hex.

export const colors = {
  // Surfaces
  paper: "#FAF8F4",
  paperCard: "#FFFFFF",
  paperMuted: "#E8E5DD",

  // Text
  ink: "#1A1815",
  inkMuted: "#6B665E",
  inkFaint: "#A39B8E",

  // Accent (rame = copper)
  rame: "#B8623A",
  rameHover: "#9F5230",

  // Status
  sageSuccess: "#5A7A4F",
  amberWarning: "#C49648",
  brickDanger: "#A04848",
} as const;

export const fonts = {
  serif: '"Crimson Pro", "EB Garamond", Georgia, serif',
  sans: 'Inter, -apple-system, BlinkMacSystemFont, system-ui, sans-serif',
  mono: '"JetBrains Mono", "SF Mono", monospace',
} as const;

export const shadows = {
  card: "0 1px 2px rgba(26,24,21,0.04), 0 4px 12px rgba(26,24,21,0.06)",
  elevated:
    "0 4px 8px rgba(26,24,21,0.08), 0 12px 32px rgba(26,24,21,0.10)",
} as const;

export const radii = {
  card: 16,
} as const;
